import { Package } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PackageGateOverlay({ pageLabel }) {
  return (
    <div
      className="fixed inset-x-0 bottom-0 top-14 z-40 flex items-center justify-center p-4 sm:p-6 lg:top-0 lg:left-64"
      data-testid="package-gate-overlay"
    >
      <div className="absolute inset-0 bg-white/30 backdrop-blur-[3px]" aria-hidden />
      <div className="relative w-full max-w-sm rounded-2xl border border-slate-200/80 bg-white p-6 shadow-[0_8px_40px_rgba(0,0,0,0.12)] sm:max-w-md sm:p-8">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-violet-100">
          <Package className="h-7 w-7 text-violet-600" />
        </div>
        <h2 className="text-center font-heading text-xl font-bold text-slate-900 sm:text-2xl">
          Paket Gerekli
        </h2>
        <p className="mt-3 text-center text-sm leading-relaxed text-slate-600 sm:text-[15px]">
          {pageLabel ? (
            <>
              Şu anda <span className="font-semibold text-slate-800">{pageLabel}</span> ekranını
              görüntülemek için aktif bir paketiniz bulunmuyor.
            </>
          ) : (
            <>Şu anda bu ekranı görüntülemek için aktif bir paketiniz bulunmuyor.</>
          )}
        </p>
        <Button
          type="button"
          className="mt-6 h-12 w-full rounded-xl bg-violet-600 text-base font-semibold text-white hover:bg-violet-700"
          data-testid="package-gate-buy-button"
        >
          Paket Satın Al
        </Button>
      </div>
    </div>
  );
}
